export const messages = {
  en: {
    meterTypeManage: {
      title: 'Meter Type Management',
      typeId: 'Meter Type ID',
      typeName: 'Name',
      ratio: 'Ratio',
      remark: 'Description',
      createTime: 'Create Time',
      operation: 'Operation',
      tip: 'If a property has multiple electricity/water meters, you can create multiple types here, e.g. Electricity Meter 1, Electricity Meter 2',
      addTitle: 'Add Meter Type',
      editTitle: 'Edit Meter Type',
      deleteTitle: 'Confirm Operation',
      deleteConfirm: 'Are you sure to delete this meter type?',
      deleteTip: 'This operation cannot be undone!',
      typeNamePlaceholder: 'Required, please enter name',
      ratioPlaceholder: 'Required, please enter ratio (e.g. 1.0, 0.1)',
      remarkPlaceholder: 'Required, please enter description',
      typeNameRequired: 'Name is required',
      typeNameMaxLength: 'Name cannot exceed 12 characters',
      ratioRequired: 'Ratio is required',
      ratioNumber: 'Ratio must be a number',
      remarkRequired: 'Description is required',
      remarkMaxLength: 'Description cannot exceed 200 characters',
      typeIdRequired: 'Meter Type ID is required',
      addSuccess: 'Added successfully',
      addFailed: 'Failed to add',
      editSuccess: 'Updated successfully',
      editFailed: 'Failed to update',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    meterTypeManage: {
      title: '抄表类型管理',
      typeId: '抄表类型ID',
      typeName: '名称',
      ratio: '倍率',
      remark: '说明',
      createTime: '创建时间',
      operation: '操作',
      tip: '如果一个房屋有多个电表水表可以在这里新建多个 比如电表1 电表2',
      addTitle: '添加抄表类型',
      editTitle: '修改抄表类型',
      deleteTitle: '确认操作',
      deleteConfirm: '确定删除该抄表类型吗？',
      deleteTip: '此操作不可撤销！',
      typeNamePlaceholder: '必填，请填写名称',
      ratioPlaceholder: '必填，请填写倍率（如 1 或 0.1）',
      remarkPlaceholder: '必填，请填写说明',
      typeNameRequired: '名称不能为空',
      typeNameMaxLength: '名称不能超过12个字符',
      ratioRequired: '倍率不能为空',
      ratioNumber: '倍率必须为数字',
      remarkRequired: '说明不能为空',
      remarkMaxLength: '说明不能超过200个字符',
      typeIdRequired: '抄表类型ID不能为空',
      addSuccess: '添加成功',
      addFailed: '添加失败',
      editSuccess: '修改成功',
      editFailed: '修改失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      fetchError: '获取数据失败'
}
  },
  'zh-TW': {
    meterTypeManage: {
      title: '抄表類型管理',
      typeId: '抄表類型ID',
      typeName: '名稱',
      ratio: '倍率',
      remark: '說明',
      createTime: '創建時間',
      operation: '操作',
      tip: '如果一個房屋有多個電錶水錶可以在這裡新建多個 比如電錶1 電錶2',
      addTitle: '添加抄表類型',
      editTitle: '修改抄表類型',
      deleteTitle: '確認操作',
      deleteConfirm: '確定刪除該抄表類型嗎？',
      deleteTip: '此操作不可撤銷！',
      typeNamePlaceholder: '必填，請填寫名稱',
      ratioPlaceholder: '必填，請填寫倍率（如 1 或 0.1）',
      remarkPlaceholder: '必填，請填寫說明',
      typeNameRequired: '名稱不能為空',
      typeNameMaxLength: '名稱不能超過12個字元',
      ratioRequired: '倍率不能為空',
      ratioNumber: '倍率必須為數字',
      remarkRequired: '說明不能為空',
      remarkMaxLength: '說明不能超過200個字元',
      typeIdRequired: '抄表類型ID不能為空',
      addSuccess: '添加成功',
      addFailed: '添加失敗',
      editSuccess: '修改成功',
      editFailed: '修改失敗',
      deleteSuccess: '刪除成功',
      deleteFailed: '刪除失敗',
      fetchError: '獲取數據失敗'
    }
  }
}